import { Injectable } from '@angular/core';

const VAT_RATE = 1.25; // 25% VAT

@Injectable({ providedIn: 'root' })
export class AdmPriceFeedbackService {
  calculateInclVat(exclVat: number): number {
    return exclVat * VAT_RATE;
  }
}
